import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const EmployerPricePage: FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default EmployerPricePage;
